import Head from 'next/head';
import { SeoLanguageLocale } from 'src/utils/getSeoLanguageLocale';
import { extendAlternateLinksWithDefault } from 'src/utils/getAlternateLinks/defaultAlternateLink';

export type AlternateLink = {
  href: string;
  hrefLang: SeoLanguageLocale;
};

export type PaginationLinks = { previous?: string | null; next?: string | null };

type Props = {
  alternateLinks: AlternateLink[];
  canonicalHref: string;
  noIndex: boolean;
  paginationLinks?: PaginationLinks;
};

export const PageUrlMeta = ({ alternateLinks, canonicalHref, noIndex, paginationLinks }: Props) => {
  return (
    <Head>
      {noIndex && <meta name="robots" content="noindex" />}
      <link rel="canonical" href={canonicalHref} />
      {extendAlternateLinksWithDefault(alternateLinks).map(link => (
        <link key={link.hrefLang} rel="alternate" href={link.href} hrefLang={link.hrefLang} />
      ))}
      {paginationLinks?.previous && <link rel="prev" href={paginationLinks.previous} />}
      {paginationLinks?.next && <link rel="next" href={paginationLinks.next} />}
    </Head>
  );
};
